<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'damage',
};
</script>

<style>
</style>
